import React from "react";
import './CategoryPage.css';

import { Heading, PageTitle, Category } from "../../../components";
import { tours } from "../../../constants";
import { getPopularTourCategories } from "../../../utils";



const CategoryPage = () => {

  // Get the Tour Categories
  const categories = getPopularTourCategories(tours);

  return (

    <>

      {/* Page title */}
      <PageTitle title={'Tour Category'} page={'Tour Category'} />

      <section className="categories">

        {/* Section Heading */}
        <Heading title={'Tour Categories'} subTitle={'Adventures by Category'} />

        {/* Category Items */}
        <div className="box-container">

          {/* Map over the categories array to render each category */}
          {categories.map(({ index, category, count, image }) => (
            <Category
              key={index}
              index={index}
              category={category}
              count={count}
              image={image}
            />
          ))}

        </div>

      </section>

    </>
  );
};

export default CategoryPage;